import React, { useState } from "react";
import { Link } from "react-router-dom";
import Appbar from "../../components/Appbar";
import { productsData } from "../../data/ProductData";

const MenProducts = () => {
  const [showProduct, setShowProduct] = useState(productsData);

  const uniqueCategories = [
    ...new Set(showProduct.map((product) => product.category)),
  ];

  const handleFilterClick = (category) => {
    const filteredProducts = productsData.filter(
      (product) => product.proSelect === category
    );
    setShowProduct(filteredProducts);
  };
  const handleShowAllClick = () => {
    setShowProduct(productsData);
  }
  const showAllButton =
    showProduct.length !== productsData.length ? (
      <button className="ind-type" onClick={handleShowAllClick}>
        Show All
      </button>
    ) : null;


  return (
    <div>
      <Appbar />
      <div className="page-section">
        
        <div>
        <div className="bread-sec">
        <Link to="/" className="bread-link">
          <u>Home</u>
        </Link>
        <Link to="/woman" className="bread-link">
          <u>Woman</u>
        </Link>
        
      </div>
          {uniqueCategories.map((category) => (
            <h2 key={category}>{category}</h2>
          ))}
        </div>
        <div className="type-sec">
          {showProduct.map((item) => (
            <div
              className="ind-type"
              onClick={() => handleFilterClick(item.proSelect)}
            >
              {item.proSelect}
            </div>
          ))}
{showAllButton}
        </div>
        <div className="men-show-sec">
          {showProduct.map((item) => (
            <div key={item.id}>
              <div className="show-pro">
                <Link to={`/multi/${item.id}`}>
                  <img src={item.proImg} alt={item.proName} />
                  <div>{item.proName}</div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenProducts;